import { RefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

const DepartmentFacet = () => {
  const dict = useSearchDictionary();

  return (
    <div className={classnames('mb-4')}>
      <div className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>{dict.department}</div>
      <RefinementList attribute="department" limit={10} sortBy={['name:asc']} showMore />
    </div>
  );
};

export default DepartmentFacet;
